<template>
  <!--  main div  -->
  <div class="d-flex flex-column mt-2 justify-content-start" style="height: 100%" id="parent">
    <!--  body div  -->
    <div :class="{ 'flex-grow-1 d-flex flex-column': true, 'elevation-2': !isLargeAndUp }" style="height: 100%">
      <v-tabs v-model="tab" class="d-flex flex flex-column flex-grow-1" style="height: 100%">
        <v-tab key="payment">Payments</v-tab>
        <!--        <v-tab key="history">History</v-tab>-->
        <v-spacer></v-spacer>
        <x-select v-if="isMediumAndUp" outlined dense class="mt-1 mr-2" :items="sessions" v-model="selectedSession"
          return-object item-text="name" placeholder="Select session" style="max-width: 20%"></x-select>
        <x-select v-if="isMediumAndUp && isSemesterBased" outlined dense class="mt-1 mr-2" :items="semesters" v-model="selectedSemester"
          return-object item-text="title" placeholder="Select semester" style="max-width: 20%"></x-select>
        <v-tabs-items v-model="tab" class="d-flex flex flex-column flex-grow-1" style="height: 100%">
          <v-tab-item key="payment" style="height: 100%">
            <v-card class="d-flex flex-column justify-start justify-md-space-between " style="height: 100%">
              <v-divider class="mb-4"></v-divider>
              <div>
                <x-select v-if="isMobile" outlined dense class="mt-3 mx-2" :items="sessions" v-model="selectedSession"
                  return-object item-text="name" placeholder="Select session"></x-select>
              </div>
              <div>
                <v-select v-if="isMobile && isSemesterBased" outlined dense class="mt-3 mx-2" :items="semesters" v-model="selectedSemester"
                  return-object item-text="title" placeholder="Select semester"></v-select>
              </div>
              <div v-if="!paymentActionEnable" class="d-flex flex-column justify-start flex-grow-1">
                <div class="mx-auto basic--text mt-2 mt-md-12">
                  <div class="text-center">No session selected</div>
                  <div class="text-center">Select a session/semester above to begin</div>
                  <!-- <div align="center" class="mt-4"><x-button color="primary" rounded elevation="0" :key="btn1" @click.once="initializeTransaction" :disabled="selectedSession == null || loading">Begin Transaction</x-button></div> -->
                </div>
              </div>
              <div v-else class="">
                <div id="doc-main" class="d-flex flex-column flex-lg-row-reverse justify-space-between"
                  style="height: 100%;">
                  <div
                    :class="{ 'mx-4': isMediumAndUp, 'mx-2': isMobile, 'mr-lg-2 mb-4': true, 'ax mx-auto': (!isLargeAndUp && !isMobile) }" style="width: 100%;">
                    <v-card elevation="0" outlined>
                      <v-card-title class="basic--text">Payments</v-card-title>
                      <v-divider></v-divider>
                      <v-card-text>
                        <div class="d-flex ">
                          <div class="flex-grow-1">
                            <div class="d-flex flex-wrap flex-md-nowrap mb-4">
                              <div class="basic--text font-weight-bold">Paid:</div>
                              <div v-if="isMobile" class="basic--text font-weight-bold ml-auto">&#8358;{{ totalAmount }}
                              </div>
                              <v-progress-linear rounded class="flex-grow-1 my-auto ml-lg-2" height="12"
                                color="primary lighten-1" background-color="primary lighten-5"
                                :value="((feePayment !==null && feePayment.clearMode === 'WAIVER') ? 100 : (amountPaid / totalAmount) * 100).toFixed()">
                                <template v-slot:default="{}">
                                  <strong>{{ (feePayment == null || (parts == null || parts.length === 0)) ? 0.00 :
                                      (feePayment.cleared ? 100 : ((amountPaid / totalAmount) * 100).toFixed())
                                  }}%</strong>
                                </template>
                              </v-progress-linear>
                            </div>
                            <div class="basic--text font-weight-bold">History</div>
                            <div v-if="feePayment == null" class="basic--text mt-6">
                              No payment history for this session
                            </div>
                            <div v-else>
                              <v-list v-for="(item, index) in parts.filter(e => !!e.amountPaid)" :key="index">
                                <v-list-item class="pl-0">
                                  <v-list-item-content class="pl-0 basic--text">
                                    {{ new Date(item.paymentDate).toLocaleString().substr(0, 10) + ' - &#8358;' +
                                  (item.amountPaid)
                                    }}
                                  </v-list-item-content>
                                </v-list-item>
                                <v-divider></v-divider>
                              </v-list>
                            </div>
                            <div class="mt-4" style="width: 100%">
                              <!-- if it's just one invoice -->
                              <x-button color="basic" depressed width="100%" class="ml-auto white--text mb-6" :key="btn2"
                                @click.once="downloadInvoice(feePayment.transactionId)" v-if="feePayment != null && feePayment.partPayments.length < 2" :disabled="loading">
                                Download Invoice</x-button>

                              <v-menu v-else-if="feePayment != null && feePayment.partPayments.length > 1" transition="slide-y-transition" left>
                                <template v-slot:activator="{ on, attrs }">
                                  <x-button class="mt-4" width="100%" color="primary" dark depressed v-bind="attrs" v-on="on">
                                    Download Invoice
                                  </x-button>
                                </template>
                                <v-list>
                                  <v-list-item
                                      v-for="(item, index) in feePayment.partPayments"
                                      link
                                      :disabled="selectedSession == null || loading" :key="index + 1"
                                      @click="downloadInvoice(item.invoice)">
                                    <v-list-item-title>Invoice {{item.invoice}}</v-list-item-title>
                                  </v-list-item>
                                </v-list>
                              </v-menu>

                              <!-- Invoice menu -->
                              <x-button class="mt-4" width="100%" color="primary" dark depressed :disabled="amountPaid >= totalAmount || loading"
                                     v-if="feePayment == null && !getUser.programme.programmeType.partPayment"
                                     @click="initializeTransaction(true, false)">
                                Generate Invoice
                              </x-button>
                              <v-menu transition="slide-y-transition" left v-else-if="feePayment == null">
                                <template v-slot:activator="{ on, attrs }">
                                  <x-button class="mt-4" width="100%" color="primary" dark depressed v-bind="attrs" v-on="on" :disabled="amountPaid >= totalAmount || loading" v-if="feePayment == null">
                                    Generate Invoice
                                  </x-button>
                                </template>
                                <v-list>
                                  <!-- Full -->
                                  <v-list-item
                                    link
                                    :disabled="selectedSession == null || loading" :key="btn1"
                                    @click="initializeTransaction(true, false)">
                                    <v-list-item-title>Full</v-list-item-title>
                                  </v-list-item>
                                  <!-- Part -->
                                  <v-list-item
                                    link
                                    :disabled="selectedSession == null || loading"
                                    v-if="getUser.programme.programmeType.partPayment" :key="btn3"
                                    @click="initializeTransaction(false, false)"
                                  >
                                    <v-list-item-title>Part</v-list-item-title>
                                  </v-list-item>
                                </v-list>
                              </v-menu>
                              <!-- for balance invoice -->
                              <x-button color="primary" width="100%" depressed class="ml-auto mt-6"
                                     :disabled="amountPaid >= totalAmount || loading || feePayment.cleared "
                                     v-if="feePayment != null && feePayment.partPayments.length > 0 && isBalancePayment && (walletBalance === null || walletBalance < remainingAmount)" @click="initializeTransaction(true, false)"
                              >Balance Invoice</x-button>
                              <x-button color="info" width="100%" depressed class="ml-auto mt-6"
                                     :disabled="amountPaid >= totalAmount || loading || feePayment.cleared || feePayment.partPayments.length > 0"
                                     v-if="feePayment != null && feePayment.partPayments.length < 1" :key="btn4" @click="makePayment(feePayment.paymentLink)"
                                >Pay Now</x-button>
                              <v-menu transition="slide-y-transition" left v-else-if="feePayment != null && !feePayment.cleared && feePayment.partPayments.length > 1">
                                <template v-slot:activator="{ on, attrs }">
                                  <x-button class="mt-4" width="100%" color="info" dark depressed v-bind="attrs" v-on="on" :disabled="amountPaid >= totalAmount || loading" >
                                    Pay now
                                  </x-button>
                                </template>
                                <v-list>
                                  <v-list-item
                                      v-for="(item, index) in feePayment.partPayments"
                                      link
                                      :disabled="loading || item.success" :key="index + 100"
                                      @click.once="makePayment(item.paymentLink, item)">
                                    <v-list-item-title>Pay for invoice {{item.invoice}} <span v-if="item.success" class="primary--text"> - Paid</span></v-list-item-title>
                                  </v-list-item>
                                </v-list>
                              </v-menu>


                              <x-button color="info" width="100%" depressed class="ml-auto mt-6" :disabled="loading"
                                     v-if="feePayment != null  && feePayment.partPayments.length < 1 && !feePayment.cleared" @click="processInvoice(feePayment.transactionId)"
                                >Request Verification</x-button>

                              <v-menu transition="slide-y-transition" left v-if="feePayment != null && !feePayment.cleared  && feePayment.partPayments.length > 1">
                                <template v-slot:activator="{ on, attrs }">
                                  <x-button class="mt-4" width="100%" color="primaryDark" dark depressed v-bind="attrs" v-on="on" :disabled="amountPaid >= totalAmount || loading" >
                                    Request verification
                                  </x-button>
                                </template>
                                <v-list>
                                  <v-list-item
                                      v-for="(item, index) in feePayment.partPayments"
                                      link
                                      :disabled="item.success" :key="index + 100"
                                      @click.once="processInvoice(item.invoice)">
                                    <v-list-item-title>Validate {{item.invoice}}</v-list-item-title>
                                  </v-list-item>
                                </v-list>
                              </v-menu>

                              <!-- Pay with Wallet -->
                              <x-button color="success" width="100%" depressed class="ml-auto mt-6"
                                     :disabled="loading || walletLoading"
                                     v-if="!isApplicant && items.length > 0 && amountPaid < totalAmount"
                                     @click="showWalletConfirmDialog">
                                <v-icon left small>mdi-wallet</v-icon>
                                Pay with Wallet
                              </x-button>
                            </div>
                          </div>
                        </div>
                      </v-card-text>
                    </v-card>
                  </div>
                  <div class="mx-auto ml-lg-6 mr-lg-0 pl-lg-1 flex-lg-grow-1" v-if="isMediumAndUp">
                    <v-sheet id="doc" elevation="0" outlined rounded class="pa-4 d-flex flex-column"
                      style="height: 297mm; width: 210mm /* size of A4 paper */">
                      <div>
                        <div class="">
                          <!--   text     -->
                          <div class="my-auto mx-auto mb-6">
                            <!-- <div class="text-center text-h5 font-weight-bold mb-3 success--text">NASARAWA STATE
                              UNIVERSITY, KEFFI</div> -->
                            <div class="text-center font-weight-bold text-uppercase">School Fees Invoice</div>
                          </div>
                          <!-- information for new students -->
                          <v-alert v-if="isApplicant" type="info">
                            Note: Sign out after payment and sign in again
                          </v-alert>
                        </div>

                        <v-sheet outlined rounded class="mt-8 mx-auto basic--text">
                          <v-simple-table dense class="basic--text">
                            <tbody>
                              <tr>
                                <th style="width: 15%">Name</th>
                                <td style="width: 35%">{{ getUser.name }}</td>
                                <th style="width: 15%">Matric:</th>
                                <td style="width: 30%">{{ getUser.userId }}</td>
                              </tr>
                              <tr>
                                <th style="width: 15%">Faculty</th>
                                <td style="width: 35%" class="text-left">{{ getUser.programme.department.faculty.name }}
                                </td>
                                <th style="width: 15%">Department:</th>
                                <td style="width: 30%">{{ getUser.programme.department.name }}</td>
                              </tr>
                              <tr>
                                <th style="width: 15%">Programme</th>
                                <td style="width: 35%" class="text-left">{{ getUser.programme.name }}</td>
                                <th style="width: 15%">Level</th>
                                <td style="width: 30%">{{ paymentInfo != null && paymentInfo.level ? paymentInfo.level.title : getUser.level.title }}</td>
                              </tr>
                              <tr>
                                <th style="width: 15%">Session</th>
                                <td style="width: 35%" class="text-left">{{ selectedSession != null ?
                                    selectedSession.name : ''
                                }}</td>
                                <th style="width: 15%">Date</th>
                                <td style="width: 35%" class="text-left">{{ new Date().toLocaleString() }}</td>
                              </tr>
                              <tr>
                                <th style="width: 15%">Email</th>
                                <td style="width: 35%" class="text-left">{{ getUser.email }}</td>
                                <th style="width: 15%">Invoice</th>
                                <td style="width: 35%" class="text-left">{{ feePayment != null ? feePayment.transactionId
                                    : 'Not generated'
                                }}</td>
                              </tr>
                              <tr v-if="isSemesterBased">
                                <th style="width: 15%">Semester</th>
                                <td style="width: 35%" class="text-left" colspan="3">{{ feePayment?.semester?.title ?? '' }}</td>
                              </tr>
                            </tbody>
                          </v-simple-table>
                        </v-sheet>

                        <v-sheet outlined rounded class="mx-auto mt-8">
                          <v-simple-table dense class="basic--text">
                            <thead>
                              <tr>
                                <th>S/N</th>
                                <th>Title</th>
                                <th class="text-right">Amount</th>
                              </tr>
                            </thead>
                            <tbody>
                              <tr v-for="(item, index) in sortedItemsWithSerialNo" :key="index">
                                <td>{{ item.sno }}</td>
                                <td>{{ item.itemTitle.title }}</td>
                                <td class="text-right">{{ item.amount }}</td>
                              </tr>
                            </tbody>
                          </v-simple-table>
                        </v-sheet>
                        <div class="text-right basic--text font-weight-bold mt-3">Total:{{ ' &#8358;' + totalAmount }}</div>
                      </div>

                    </v-sheet>
                  </div>

                  <v-alert class="mx-2" v-else type="warning">
                    Use desktop view to view and print documents
                  </v-alert>

                </div>
              </div>
            </v-card>
          </v-tab-item>

          <v-tab-item key="history">
            <v-divider class="mb-4"></v-divider>

          </v-tab-item>
        </v-tabs-items>
      </v-tabs>
    </div>
    <!-- Wallet Payment Confirmation Dialog -->
    <v-dialog v-model="showWalletDialog" max-width="450" persistent>
      <v-card>
        <v-card-title class="text-h6">
          <v-icon left color="success">mdi-wallet</v-icon>
          Pay with Wallet
        </v-card-title>
        <v-divider></v-divider>
        <v-card-text class="pt-4">
          <v-simple-table dense>
            <tbody>
              <tr>
                <td class="font-weight-bold">Total Fee</td>
                <td class="text-right">&#8358;{{ formatCurrency(totalAmount) }}</td>
              </tr>
              <tr v-if="amountPaid > 0">
                <td class="font-weight-bold">Already Paid</td>
                <td class="text-right success--text">&#8358;{{ formatCurrency(amountPaid) }}</td>
              </tr>
              <tr>
                <td class="font-weight-bold">Amount Due</td>
                <td class="text-right font-weight-bold">&#8358;{{ formatCurrency(remainingAmount) }}</td>
              </tr>
              <tr>
                <td class="font-weight-bold">Wallet Balance</td>
                <td class="text-right font-weight-bold" :class="walletBalance >= remainingAmount ? 'success--text' : 'error--text'">
                  <span v-if="walletLoading">Loading...</span>
                  <span v-else-if="walletBalance !== null">&#8358;{{ formatCurrency(walletBalance) }}</span>
                  <span v-else class="grey--text">Unavailable</span>
                </td>
              </tr>
            </tbody>
          </v-simple-table>
          <v-alert v-if="walletBalance !== null && walletBalance < remainingAmount" type="error" dense class="mt-4 mb-0">
            Insufficient wallet balance. You need &#8358;{{ formatCurrency(remainingAmount - walletBalance) }} more.
          </v-alert>
          <v-alert v-else-if="walletBalance !== null && walletBalance >= remainingAmount" type="info" dense class="mt-4 mb-0">
            &#8358;{{ formatCurrency(remainingAmount) }} will be debited from your wallet.
          </v-alert>
        </v-card-text>
        <v-divider></v-divider>
        <v-card-actions>
          <v-spacer></v-spacer>
          <x-button text @click="showWalletDialog = false" :disabled="walletPaymentLoading">Cancel</x-button>
          <x-button color="success" depressed @click="confirmWalletPayment"
            :disabled="walletBalance === null || walletBalance < remainingAmount || walletPaymentLoading"
            :loading="walletPaymentLoading">
            Confirm Payment
          </x-button>
        </v-card-actions>
      </v-card>
    </v-dialog>

    <loading-dialog :show="loading"></loading-dialog>
    <message-box :show="messageShow" :message="message" :type="messageType"
      v-on:close-message="messageShow = !messageShow"></message-box>
  </div>
</template>


<script>
import LoadingDialog from "@ui/components/LoadingDialog";
import MessageBox from "@ui/components/MessageBox";
import { mapGetters } from "vuex";
import Api from "@/main/api";
import ErrorResolver from "@/shared/ErrorResolver";
import LoginUtil from "../../login/LoginUtil";
import { PaymentGateway } from "@/shared/PaymentGateway";
import GateWays from "@/shared/GateWays";
import Roles from "@/shared/Roles";
import Links from "@/shared/constants/Links";
import PaymentModes from "shared/PaymentModes";
import XButton from '@ui/widgets/XButton.vue';
import XSelect from "@ui/widgets/XSelect.vue";

export default {
  name: "SchoolFees",
  components: { MessageBox, LoadingDialog, XButton, XSelect },
  data: () => ({
    messageType: '',
    message: '',
    messageShow: false,
    loading: false,
    tab: null,
    feePayment: null,
    items: [],
    paymentInfo: null,
    sessions: [],
    selectedSession: null,
    parts: [], // parts
    payPart: false,
    amountToPay: 0,
    paymentGateway: null,
    paymentConfig: null,
    isSemesterBased: false,
    selectedSemester: null,
    semesters: [],
    btn1: 1,
    btn2: 100,
    btn3: 1000,
    btn4: 2000,
    btn5: 3000,
    walletBalance: null,
    walletLoading: false,
    showWalletDialog: false,
    walletPaymentLoading: false,
  }),

  computed: {
    ...mapGetters(['getUser']),
    isLargeAndUp: function () {
      return this.$vuetify.breakpoint.lgAndUp
    },

    isMobile: function () {
      return this.$vuetify.breakpoint.smAndDown
    },

    isMedium: function () {
      return this.$vuetify.breakpoint.mdOnly
    },

    isMediumAndDown: function () {
      return this.$vuetify.breakpoint.mdAndDown
    },


    isMediumAndUp: function () {
      return this.$vuetify.breakpoint.mdAndUp
    },

    itemsWithSerialNo() {
      return this.items.map((d, index) => ({ ...d, sno: index + 1 }))
    },

    sortedItemsWithSerialNo() {
      return [...this.items]
        .sort((a, b) => a.itemTitle.title.localeCompare(b.itemTitle.title))
        .map((d, index) => ({ ...d, sno: index + 1 }))
    },

    totalAmount: function () {
      return this.items.map(value => value.amount).reduce((previousValue, currentValue) => previousValue + currentValue, 0)
    },

    isBalancePayment: function(){
      return (this.feePayment != null && this.feePayment.partPayments.length > 0 && !this.feePayment.cleared) ||
          (this.amountPaid < this.totalAmount && this.feePayment.partPayments.length > 0)
    },

    amountPaid: function () {
      if(this.feePayment != null && this.feePayment.cleared)
        return this.totalAmount

      if (this.parts != null && this.parts.length < 1) {
        return 0;
      }

      return this.parts.map(e => e.amountPaid).reduce((previousValue, currentValue) => previousValue + currentValue, 0);
    },

    canClickPay: function () {
      return /^[123456789]\d*(\.\d{0,8})?$/.test(this.amountToPay) && Number.parseFloat(this.amountToPay) <= (this.totalAmount - this.amountPaid)
    },

    isApplicant: function () {
      return this.getUser != null && Roles.contains(this.getUser.roles, Roles.Applicant)
    },

    paymentActionEnable: function(){
      return (this.isSemesterBased && !!this.selectedSemester) || (!this.isSemesterBased && !!this.selectedSession)
    },

    remainingAmount: function () {
      return this.totalAmount - this.amountPaid
    }
  },

  methods: {
    remountClickOnce(){
      this.btn1++;
      this.btn2++;
      this.btn3++;
      this.btn4++;
      this.btn5++;
    },
    getPayment() {
      if (this.getUser != null && this.selectedSession != null) {
        this.loading = true;
        this.feePayment = null
        this.items = [];
        this.parts = [];
        Api.schoolFees.getFeeFor(this.selectedSession.id, this.getUser.userId, this.selectedSemester?.id ?? null)
          .then(res => {
            this.feePayment = res.data.feePayment
            this.items = res.data.feeItems
            this.paymentInfo = res.data
            if (res.data.feePayment != null) {
              this.parts = this.feePayment.partPayments

            }
          }).catch(err => ErrorResolver.checkErrors(this, err))
          .finally(() => this.loading = false)
      }
    },

    processInvoice(invoiceNumber){
      if(!invoiceNumber)
        return
      this.loading = true
      Api.payment.processInline(invoiceNumber)
          .then(() => this.$notify({type: 'success', message: 'Invoice verified'}))
          .catch(err => ErrorResolver.process(this, err))
          .finally(() => this.loading = false)
    },

    initializeTransaction(full, payNow) {
      if (this.getUser != null && this.paymentActionEnable) {
        this.loading = true;
        Api.schoolFees.initializePayment({
          sessionId: this.selectedSession.id,
          studentReg: this.getUser.userId,
          full: full,
          semesterId: this.selectedSemester?.id ?? null
        })
          .then(() => {
            this.message = 'Transaction initialized'
            this.messageType = 'success'
            this.messageShow = true
            // this.feePayment = res.data
            this.getPayment()
            window.location.reload()
            if(payNow){
              this.makePayment()
            }
          }).catch(err => ErrorResolver.checkErrors(this, err))
          .finally(() => this.loading = false)
      }
    },

    // invoice download
    downloadInvoice(invoice) {
      this.loading = true;

      Api.schoolFees.invoice(invoice)
        .then(res => {
          let fileURL = window.URL.createObjectURL(new Blob([res.data], { type: 'application/pdf' }));
          window.open(fileURL, '_blank');
        }).catch(() => {
          // ErrorReslover.checkErrors(this, err);
          this.message = "Failed to Download Invoice"
          this.messageType = "error"
          this.messageShow = true
          // err.message = "Failed to Download Invoice"
        }).finally(() => this.loading = false)
    },

    // TODO: To be removed
    refreshTransaction() {
      if (this.getUser != null && this.selectedSession != null && this.feePayment != null) {
        this.loading = true;
        Api.schoolFees.refreshTransaction(this.feePayment.id)
          .then(res => {
            this.getPayment()
            this.feePayment = res.data;
            this.message = 'Transaction refreshed'
            this.messageType = 'success'
            this.messageShow = true
          }).catch(err => ErrorResolver.checkErrors(this, err))
          .finally(() => this.loading = false)
      }
    },

    // eslint-disable-next-line no-unused-vars
    makePayment(link, payment) {
      if (this.feePayment != null) {
        if (this.paymentConfig.inline) {
          this.paymentGateway.makePayment({
            email: this.getUser.email,
            amount: this.payPart ? this.amountToPay : (this.totalAmount - this.amountPaid),
            currency: 'NGN',
            invoice: payment?.invoice ?? this.feePayment.transactionId,
            paymentId: payment?.feePayment?.id ?? this.feePayment.id
          }, () => {
            // if its an applicant, logout 'em out
            if (this.isApplicant) {
              LoginUtil.resetAccessToken()
              LoginUtil.resetRefreshToken()
              window.location.href = '/login'
            } else {
              window.location.reload()
            }
          }, (invoice) => {
            // process
            this.loading = true
            Api.payment.processInline(invoice)
                .then(() => {
                  window.location.href = "/application"
                }).catch(err => {
              ErrorResolver.checkErrors(this, err)
              this.loading = false
            })
          })
        } else {
          // payment should not be done inline
          // open window for payment
          this.loading = true
          window.location.href = link
        }
      }
    },

    fetchSessionsForPayment() {
      if (this.getUser != null) {
        this.loading = true;
        Api.session.getSessionsForPayment(this.getUser.userId)
          .then(res => this.sessions = res.data)
          .catch(err => ErrorResolver.checkErrors(this, err))
          .finally(() => this.loading = false);
      }
    },

    fetchSemestersForPayment() {
      if (this.getUser != null && this.selectedSession) {
        this.loading = true;
        Api.semester.getPaidAndPending(this.getUser.userId, this.selectedSession.id)
          .then(res => this.semesters = res.data)
          .catch(err => ErrorResolver.checkErrors(this, err))
          .finally(() => this.loading = false);
      }
    },

    print() {
      window.print()
    },

    async fetchWalletBalance() {
      if (this.isApplicant) return
      this.walletLoading = true
      try {
        const { data } = await Api.wallet.getSummary()
        this.walletBalance = data.currentBalance ?? 0
      } catch (e) {
        console.error('Failed to fetch wallet balance', e)
        this.walletBalance = null
      } finally {
        this.walletLoading = false
      }
    },

    showWalletConfirmDialog() {
      this.fetchWalletBalance()
      this.showWalletDialog = true
    },

    async confirmWalletPayment() {
      this.walletPaymentLoading = true
      try {
        const { data } = await Api.schoolFees.payWithWallet({
          sessionId: this.selectedSession.id,
          semesterId: this.selectedSemester?.id ?? null,
          studentReg: this.getUser.userId
        })
        this.showWalletDialog = false
        this.$notify({
          type: 'success',
          message: data.message || 'School fee paid successfully with wallet'
        })
        this.walletBalance = data.walletBalanceAfter ?? null
        this.getPayment()
      } catch (err) {
        ErrorResolver.process(this, err)
      } finally {
        this.walletPaymentLoading = false
      }
    },

    formatCurrency(value) {
      if (value === null || value === undefined) return '0.00'
      return Number(value).toLocaleString('en-NG', { minimumFractionDigits: 2, maximumFractionDigits: 2 })
    },
  },

  watch: {
    selectedSession: function (newVal) {
      this.isSemesterBased = false
      if (newVal != null) {
        this.isSemesterBased = newVal.paymentMode == PaymentModes.SEMESTER.text
        // console.log(this.isSemesterBased)
        if(this.isSemesterBased){
          this.fetchSemestersForPayment()
        } else{
          this.getPayment()
        }
      }
    },

    selectedSemester: function(val){
      val && this.getPayment()
    },

    getUser: function () {
      this.fetchSessionsForPayment()
    },

    loading: function(val){
      if(val){
        this.remountClickOnce()
      }
    }
  },

  created() {
    this.fetchSessionsForPayment()
    this.fetchWalletBalance()
  },

  mounted() {
    // initialize gateway
    this.$nextTick(() => {
      this.paymentGateway = new PaymentGateway(GateWays.PAYSTACK, this, Links.payments.processInlinePayment)
      Api.paymentPlatforms.getActive()
        .then(res => {
          if (this.paymentGateway != null) {
            // set config
            this.paymentConfig = res.data
            // if inline, initialize
            if (res.data.inline)
              this.paymentGateway.initializeGateway(res.data)
          } else {
            this.message = 'No payment settings found'
            this.messageType = 'error'
            this.messageShow = true
          }
        }).catch(err => ErrorResolver.checkErrors(this, err))

    })
  }
}
</script>

<style scoped>
.ax {
  width: 210mm
}

@media print {
  #doc {
    position: fixed;
    top: 0;
    left: 0;
    z-index: 99999;
  }

  #actions {
    display: none;
    height: 0;
    width: 0;
  }
}

@page {
  margin: 0;
}
</style>
